import { render, staticRenderFns } from "./ActiveOrderCustomerByStatus.vue?vue&type=template&id=00fbeeaf&"
import script from "./ActiveOrderCustomerByStatus.vue?vue&type=script&lang=js&"
export * from "./ActiveOrderCustomerByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports